// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2yQl2","productName":"Table_productName__1EFqW"};